export function getErrorMessage(error) {
	if (error.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		if (error.response.status >= 500 && error.response.status <= 599) {
			if (error.response?.data?.message === "could not execute batch; nested exception is org.hibernate.exception.GenericJDBCException: could not execute batch") {
				return "Ops, uno o più file non rispettano la dimensione minima!";
			}
			return "Ops, il server ha qualche problema, ci scusiamo per il disagio. Ripariamo subito!";
		} else if (error.response.status === 400) {
			return error.response.data.message;
		} else if (error.response.status === 401) {
			if (error.response.data && error.response.data.message) {
				return error.response.data.message;
			} else {
				return "Ops, non sei autorozzato ad effettuare questa operazione"
			}
		} else if (error.response.status === 403) {
			return "Non hai i permessi per effettuare questa operazione";
		} else if (error.response.status === 404) {
			if (error.response.data && error.response.data.message) {
				return error.response.data.message;
			} else {
				return "Ops, qualcosa non ha funzionato...";
			}
		} else if (error.response.status === 415) {
			return "Unsupported Media Type"
		} else if (error.response.status === 405) {
			return "Ops, il server ha qualche problema, ci scusiamo per il disagio";
		}
	} else if (error.request) {
		// The request was made but no response was received
		// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
		// http.ClientRequest in node.js
		window.location.reload();
		return "La richiesta è stata fatta ma non ha ricevuto risposte ..."
	} else {
		// Something happened in setting up the request that triggered an Error
		return "Ops, qualcosa non ha funzionato";
	}
}
